import { Activity, type PropsWithChildren, type ReactNode } from 'react'

export interface LoadingWrapperProps {
  loading: boolean
  loadingElement?: ReactNode | null
}

export function LoadingWrapper({ loading, loadingElement = null, children }: PropsWithChildren<LoadingWrapperProps>) {
  return (
    <>
      <Activity mode={loading ? 'visible' : 'hidden'}>{loadingElement}</Activity>
      <Activity mode={loading ? 'hidden' : 'visible'}>{children}</Activity>
    </>
  )
}
